export default __webpack_public_path__ + "static/Porsche Caayenne-1d544651445cfa4416c9f757ad0879d2.jpg";